/* unplugin-vue-components disabled */import script from "./Step3.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step3.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__